/*
 * jv-bridal-hub-trial-modal.js
 *
 * Trial-modal JS for the bridal hub. Extracted verbatim from sections/jv-bridal-hub.liquid
 * (lines 2074-2419, ~14 KB) to bring the section under Shopify's 256 KB upload limit
 * so the TBC getting-ready-address tile can ship.
 *
 * Liquid-resolved values are injected as `window.JV_TRIAL_MODAL_CONFIG` by an inline
 * <script> block in the section file BEFORE this asset loads. Do NOT add new Liquid
 * references inside this asset — add them to the inline config block instead.
 *
 * Per CLAUDE.md "captured native fetch" rule: this script uses window._jvNativeFetch
 * (captured by the next inline <script> in the section file). It must continue to do so.
 *
 * Per CLAUDE.md "bridal hub direct GAS calls": every gasPost MUST include both email
 * AND customerId. The original block enforced this — DO NOT change that contract.
 */
(function () {
  var CFG = window.JV_TRIAL_MODAL_CONFIG || {};

  document.addEventListener('DOMContentLoaded', function () {
    var trialModal = document.getElementById('jv-trial-modal');
    if (!trialModal) return;

    /*
      INTEGRATION NOTE:
      The current Apps Script `trial_update` endpoint still expects a shared secret in the request body.
      This theme sends the configured value for compatibility with the existing backend contract.
      When backend auth is upgraded, remove the theme-side secret and switch to server-verified requests.
    */

    var openButtons = document.querySelectorAll('.js-open-trial-modal');
    var closeButtons = trialModal.querySelectorAll('.js-trial-modal-close');
    var backButtons = trialModal.querySelectorAll('.js-trial-back');
    var choiceButtons = trialModal.querySelectorAll('.js-trial-choice');

    var stepStart = trialModal.querySelector('.jv-trial-step--1');
    var stepBooked = trialModal.querySelector('.jv-trial-step--booked');
    var stepNoTrial = trialModal.querySelector('.jv-trial-step--no-trial');
    var stepBookNow = trialModal.querySelector('.jv-trial-step--book-now');

    var statusEls = trialModal.querySelectorAll('.js-trial-status');
    var backdrop = trialModal.querySelector('.jv-modal__backdrop');
    var dialog = trialModal.querySelector('.jv-modal__dialog');
    var lastTrigger = null;
    var existingTrialDate = CFG.existingTrialDate || '';
    var existingTrialType = CFG.existingTrialType || '';
    var existingTrialMode = CFG.existingTrialMode || '';
    var existingTrialOptOut = !!CFG.existingTrialOptOut;
    var studioBookingUrl = CFG.studioBookingUrl || '/pages/bridal-trial';
    var mobileBookingUrl = CFG.mobileBookingUrl || '/pages/mobile-bridal-trial';
    var submitButtons = trialModal.querySelectorAll('.js-trial-submit-booked, .js-trial-submit-no-trial, .js-trial-submit-book-now');

    function normaliseTrialModeValue(value) {
      var raw = String(value || '').trim();
      if (!raw) return '';
      var cleaned = raw.replace(/[\[\]\"]/g, '').split(',')[0];
      var key = cleaned.trim().toLowerCase();
      if (key.indexOf('mobile') > -1) return 'Mobile';
      if (key.indexOf('studio') > -1) return 'Studio';
      return cleaned.trim();
    }

    function setButtonsDisabled(disabled) {
      submitButtons.forEach(function (btn) {
        btn.disabled = !!disabled;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
    }

    function focusCurrentStep() {
      var activeStep = trialModal.querySelector('.jv-trial-step.is-active');
      if (!activeStep) return;

      var focusTarget = activeStep.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])') || dialog;
      if (focusTarget) focusTarget.focus();
    }

    function clearStatus() {
      statusEls.forEach(function (el) {
        el.textContent = '';
        el.classList.remove('is-error');
        el.classList.remove('is-success');
      });
    }

    function updateStatus(message, isError) {
      statusEls.forEach(function (el) {
        el.textContent = message || '';
        el.classList.toggle('is-error', !!isError);
        el.classList.toggle('is-success', !isError && !!message);
      });
    }

    function prefillTrialFields() {
      var bookedDate = document.getElementById('jv-trial-date-booked');
      var bookedType = document.getElementById('jv-trial-type-booked');
      var bookedMode = document.getElementById('jv-trial-mode-booked');
      var bookNowType = document.getElementById('jv-trial-type-book-now');
      var bookNowMode = document.getElementById('jv-trial-mode-book-now');
      var modeValue = normaliseTrialModeValue(existingTrialMode);

      if (bookedDate) bookedDate.value = existingTrialDate || '';
      if (bookedType) bookedType.value = existingTrialType || '/';
      if (bookedMode) bookedMode.value = modeValue || '/';
      if (bookNowType) bookNowType.value = existingTrialType || '/';
      if (bookNowMode) bookNowMode.value = modeValue || '/';
    }

    function showStep(stepEl) {
      clearStatus();
      var allSteps = trialModal.querySelectorAll('.jv-trial-step');
      allSteps.forEach(function (s) { s.classList.remove('is-active'); });
      if (stepEl) stepEl.classList.add('is-active');

      window.requestAnimationFrame(focusCurrentStep);
    }

    // Fetches trial entitlement from GAS and shows a state-aware note
    // above the type/mode dropdowns. Non-fatal — if the fetch fails or the
    // page can't reach GAS, the modal still works with no note.
    //
    // Uses captured native fetch + own POST (the page-level gasPost lives in
    // a later DOMContentLoaded closure and isn't reachable from this scope).
    // Per project rule: must include BOTH email AND customerId for auth.
    function loadTrialStateNote() {
      var note = document.getElementById('jv-trial-state-note');
      if (!note) return;
      var email      = CFG.customerEmail || '';
      var customerId = CFG.customerId || '';
      if (!email || !customerId) return;
      // FIXED 2026-08-13 (raw-GAS-URL bypass sweep): was a raw GAS URL, bypassing the
      // Cloudflare CORS relay that absorbs the ~7-10s GAS cold-start.
      // WIRED 2026-08-21 (BRIEF-04A follow-up): resolves through the route->backend
      // map in jv-bridal-hub-resilience.js instead of a second hardcoded literal, so
      // this route's backend can be changed in the one place the map controls. Falls
      // back to the same relay URL if the resilience asset hasn't loaded yet (should
      // not happen -- it loads blocking before this file per the section's script
      // order -- but never let a load-order edge case post to "undefined").
      var _GAS = (window.jvHub && window.jvHub.resolveUrl)
        ? window.jvHub.resolveUrl('bridge_client_getTrialEntitlement')
        : 'https://broken-truth-efdd.calm-hill-fd5b.workers.dev';
      var _fetch = (window._jvNativeFetch || window.fetch).bind(window);
      _fetch(_GAS, {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ route: 'bridge_client_getTrialEntitlement', email: email, customerId: customerId })
      }).then(function(r){ return r.text(); }).then(function(text) {
        var data = null;
        try { data = JSON.parse(text); } catch(e) {}
        if (!data || data.status !== 'ok' || !data.state) {
          note.style.display = 'none';
          return;
        }
        var msg = '';
        switch (data.state) {
          case 'studio_paid':
            msg = '<strong>Your bridal package includes a studio trial.</strong><br>' +
                  'Choosing <em>Mobile</em> will add a calculated travel fee (A$0.95/km return) at booking. ' +
                  'Mobile trials are capped at 50km from our studio.';
            break;
          case 'mobile_paid':
            msg = '<strong>Your bridal package includes a mobile trial.</strong><br>' +
                  'Pick the location that works best for you, no additional payment required.';
            break;
          case 'unpaid':
            msg = '<strong>Standalone trial booking.</strong><br>' +
                  'A$324.50 for a Hair &amp; Makeup trial. Mobile bookings add a calculated travel fee.';
            break;
          case 'already_booked':
            msg = '<strong>Your trial is already booked' +
                  (data.trialDate ? ' for ' + data.trialDate : '') +
                  '.</strong><br>Contact the Pro Team if you need to reschedule.';
            break;
          default:
            note.style.display = 'none';
            return;
        }
        note.innerHTML = msg;
        note.style.display = 'block';
      }).catch(function() { note.style.display = 'none'; });
    }

    function openModal(e) {
      if (e) e.preventDefault();
      lastTrigger = e && e.currentTarget ? e.currentTarget : document.activeElement;
      prefillTrialFields();
      showStep(stepStart);
      if (existingTrialOptOut) {
        updateStatus('Your account is currently marked as not having a trial. You can update that here if needed.', false);
      }
      loadTrialStateNote();
      trialModal.classList.add('is-visible');
      trialModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal(e) {
      if (e) e.preventDefault();
      trialModal.classList.remove('is-visible');
      trialModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && trialModal.classList.contains('is-visible')) {
        closeModal();
      }
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { showStep(stepStart); });
    });

    choiceButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var choice = btn.getAttribute('data-choice');
        if (choice === 'already-booked') showStep(stepBooked);
        if (choice === 'book-now') showStep(stepBookNow);
        if (choice === 'no-trial') showStep(stepNoTrial);
      });
    });

    // FIXED 2026-08-13 (raw-GAS-URL bypass sweep): was a raw GAS URL, bypassing the
    // Cloudflare CORS relay that absorbs the ~7-10s GAS cold-start. This one backs a live WRITE
    // (bridge_bride_updateTrial below), so the fix has real perceived-latency impact.
    // WIRED 2026-08-21 (BRIEF-04A follow-up): resolves through the route->backend map
    // in jv-bridal-hub-resilience.js -- see the loadTrialStateNote() note above for
    // the full rationale (identical pattern, this is the other of the two routes this
    // file owns).
    var TRIAL_GAS_EXEC = (window.jvHub && window.jvHub.resolveUrl)
      ? window.jvHub.resolveUrl('bridge_bride_updateTrial')
      : 'https://broken-truth-efdd.calm-hill-fd5b.workers.dev';
    var TRIAL_CUSTOMER_EMAIL = CFG.customerEmail || '';
    var TRIAL_CUSTOMER_ID = CFG.customerId || '';

    function submitTrialUpdate(payload, onSuccess) {
      clearStatus();
      updateStatus('Saving your trial details...');
      setButtonsDisabled(true);

      if (!TRIAL_CUSTOMER_EMAIL || !TRIAL_CUSTOMER_ID) {
        updateStatus('We could not match this account to your bridal record. Please contact the Pro Team so we can check your portal access.', true);
        setButtonsDisabled(false);
        return;
      }

      var body = {
        route: 'bridge_bride_updateTrial',
        email: TRIAL_CUSTOMER_EMAIL,
        customerId: TRIAL_CUSTOMER_ID
      };
      if (payload && typeof payload === 'object') {
        Object.keys(payload).forEach(function (k) { body[k] = payload[k]; });
      }

      var nativeFetch = (window._jvNativeFetch || window.fetch).bind(window);
      nativeFetch(TRIAL_GAS_EXEC, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.text().then(function (text) {
          var data = null;
          try { data = text ? JSON.parse(text) : null; } catch (error) {}
          if (!res.ok || !data || data.ok === false || (data.status && data.status !== 'ok')) {
            throw new Error((data && (data.error || data.message)) || 'Could not save your update.');
          }
          updateStatus('Saved. Your Bridal Hub will refresh after your update is processed.');
          setButtonsDisabled(false);
          if (typeof onSuccess === 'function') onSuccess();
        });
      }).catch(function (error) {
        var message = error && error.message ? error.message : 'We could not confirm your update was saved. Please try again or contact the Pro Team.';
        var lower = String(message).toLowerCase();
        if (lower.indexOf('trial_date is required') > -1) {
          message = 'Please choose your trial date before saving.';
        } else if (lower.indexOf('authentication') > -1 || lower.indexOf('no shopify customer found') > -1 || lower.indexOf('email mismatch') > -1) {
          message = 'We could not match this account to your bridal record. Please contact the Pro Team so we can check your portal access.';
        }
        updateStatus(message, true);
        setButtonsDisabled(false);
      });
    }

    var bookedBtn = trialModal.querySelector('.js-trial-submit-booked');
    if (bookedBtn) {
      bookedBtn.addEventListener('click', function () {
        var dateEl = document.getElementById('jv-trial-date-booked');
        var typeEl = document.getElementById('jv-trial-type-booked');
        var modeEl = document.getElementById('jv-trial-mode-booked');

        var dateVal = dateEl ? dateEl.value : '';
        var typeVal = typeEl ? typeEl.value : '';
        var modeVal = modeEl ? modeEl.value : '';

        if (!dateVal) {
          updateStatus('Please choose your trial date.', true);
          return;
        }

        if (!typeVal || typeVal === '/') {
          updateStatus('Please choose the type of trial.', true);
          return;
        }

        if (!modeVal || modeVal === '/') {
          updateStatus('Please choose where your trial is happening.', true);
          return;
        }

        submitTrialUpdate({
          trial_booked: true,
          trial_opted_out: false,
          trial_date: dateVal,
          trial_type: typeVal,
          trial_mode: modeVal
        });
      });
    }

    var noTrialBtn = trialModal.querySelector('.js-trial-submit-no-trial');
    if (noTrialBtn) {
      noTrialBtn.addEventListener('click', function () {
        submitTrialUpdate({
          trial_booked: false,
          trial_opted_out: true,
          trial_date: '',
          trial_type: '',
          trial_mode: ''
        }, function () {
          setTimeout(closeModal, 500);
        });
      });
    }

    var bookNowBtn = trialModal.querySelector('.js-trial-submit-book-now');
    if (bookNowBtn) {
      bookNowBtn.addEventListener('click', function () {
        var typeEl = document.getElementById('jv-trial-type-book-now');
        var modeEl = document.getElementById('jv-trial-mode-book-now');
        var typeVal = typeEl ? typeEl.value : '';
        var modeVal = modeEl ? modeEl.value : '';

        if (!typeVal || typeVal === '/') {
          updateStatus('Please choose the type of trial you are booking.', true);
          return;
        }

        if (!modeVal || modeVal === '/') {
          updateStatus('Please choose where you would like your trial.', true);
          return;
        }

        submitTrialUpdate({
          trial_booked: false,
          trial_opted_out: false,
          trial_type: typeVal,
          trial_mode: modeVal
        }, function () {
          window.location.href = modeVal === 'Mobile' ? mobileBookingUrl : studioBookingUrl;
        });
      });
    }
  });
})();
